export default "__VITE_ASSET__3eee2476__"